import React from 'react'

function CareerDetails({ careerDetails }) {
   return (
      <>
         <div dangerouslySetInnerHTML={{ __html: careerDetails.description }} />
      </>
   )
}

export default CareerDetails
